<div class="heading">
  <div class="heading__back">
    <button
      *ngIf="backOnClick.observers.length > 0"
      [ngClass]="{
        'heading__button--disabled': isActivateAction(),
        'heading__button--cancel': isDelete()
      }"
      [disabled]="isActivateAction()"
      class="heading__button heading__button--back"
      (click)="emitBackOnClick()"
    >
      <img src="/assets/back.svg" alt="Back" />
    </button>
  </div>
  <div class="heading__title">
    <ng-content></ng-content>
  </div>
  <div class="heading__action">
    <button
      *ngIf="isActionButton()"
      [ngClass]="{
        'heading__button--active': isActive(),
        'heading__button--disabled': isDisabled(),
        'heading__button--delete': isDelete()
      }"
      [disabled]="isDisabled()"
      class="heading__button heading__button--action"
      (click)="isCancelled() ? emitCancelOnClick() : emitActionOnClick()"
    >
      <img *ngIf="!!actionConfig.icon" [src]="actionConfig.icon" alt="action icon" />
      {{ actionConfig.label | translate }}
    </button>
    <div *ngIf="isActionIndicator()" class="heading__action__indicator">
      <frodo-connection-indicator></frodo-connection-indicator>
    </div>
  </div>
</div>
